export const CORNERS = {
  CORNERS_0: '--corners-0',
  CORNERS_5: '--corners-5',
  CORNERS_10: '--corners-10',
  CORNERS_20: '--corners-20',
  CORNERS_25: '--corners-25',
  CORNERS_30: '--corners-30',
  CORNERS_40: '--corners-40',
  CORNERS_50: '--corners-50',
  CORNERS_PILL: '--corners-pill',
  CORNERS_ROUND: '--corners-round',

  CORNERS_BOTTOM_10: '--corners-bottom-10',

  CORNERS_LEFT_10: '--corners-left-10',
  CORNERS_RIGHT_10: `--corners-right-10`,
  CORNERS_LEFT_TOP_10: '--corners-left-top-10',

  CORNERS_LEFT_TOP_25: '--corners-left-top-25',
  CORNERS_RIGHT_BOTTOM_25: '--corners-right-bottom-25',

  //for carousel buttons
  CORNERS_RIGHT_25: `--corners-right-25`,
  CORNERS_LEFT_25: `--corners-left-25`,
} as const
export type CORNERS = (typeof CORNERS)[keyof typeof CORNERS]
